import { render } from "./index.vue?vue&type=template&id=fae3aa4c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=fae3aa4c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__